<template>
  <div class="mt-4">
    <v-row>
      <v-col cols="12" md="4">
        <h4>2.8 Composition du dispositif et accessoires</h4>
      </v-col>
      <v-col>
        <span v-if="!readOnly">
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="error"
                v-bind="attrs"
                v-on="on"
                @click.stop="promptConfirmDeletion()"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </template>
            <span>Supprimer tous les éléments constitutifs</span>
          </v-tooltip>
          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="success"
                v-bind="attrs"
                v-on="on"
                @click.stop="append"
              >
                <v-icon>mdi-plus-box</v-icon>
              </v-btn>
            </template>
            <span>Ajouter un élément</span>
          </v-tooltip>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-data-table
        class="mt-0"
        :items="elements"
        :headers="headers"
        no-data-text="Aucun élément constitutif"
        :hide-default-header="!elements[0]"
        hide-default-footer
        dense
        disable-pagination
        disable-sort
        disable-filtering
      >
        <template v-slot:[`item.commands`]="{ index }">
          <v-row
            style="flex-wrap: nowrap"
            align="center"
            justify="space-around"
          >
            <v-btn
              :disabled="readOnly"
              icon
              color="info"
              @click.stop="edit(index)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              :disabled="readOnly"
              icon
              color="error"
              @click.stop="promptConfirmDeletion(index)"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>

      <v-dialog persistent v-model="showDelConfirm" max-width="410">
        <v-card>
          <v-card-title class="text-h5">
            Confirmation de suppression
          </v-card-title>
          <v-card-text>
            <div v-if="deleteIndex != null">
              Confirmez-vous la suppression de l'élément
              {{ elementASupprimer }} ?
            </div>
            <div v-else>
              Confirmez-vous la suppression de tous les éléments constitutifs ?
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="doDeletion"> Oui </v-btn>
            <v-btn color="success" text @click="cancelDeletion"> Non </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <produit-element-dialog
        :show="showDialog"
        :editedElement="elementEdite"
        @ok="confirmElementDialog"
        @cancel="showDialog = false"
      ></produit-element-dialog>
    </v-row>
  </div>
</template>

<script>
// import FournisseurService from "@/services/FournisseurService";
import ProduitElementDialog from "@/components/ProduitElementDialog";

export default {
  name: "ProduitComposition",
  components: {
    ProduitElementDialog,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: "Elément", value: "element" },
        { text: "Matériau", value: "materiau" },
        { text: " ", value: "commands" },
      ],
      showDelConfirm: false,
      deleteIndex: null,
      showDialog: false,
      editIndex: null,
    };
  },
  computed: {
    elements() {
      return this.$store.state.demandeEditee.produit.elements;
    },
    elementASupprimer() {
      if (this.deleteIndex != null) {
        return this.elements[this.deleteIndex].element;
      }
      return "";
    },
    elementEdite() {
      //console.log(this.editIndex);
      if (this.editIndex != null) {
        return this.elements[this.editIndex];
      }
      return null;
    },
  },
  methods: {
    promptConfirmDeletion(index = null) {
      //console.log(index);
      this.deleteIndex = index;
      this.showDelConfirm = true;
    },
    doDeletion() {
      if (this.deleteIndex != null) {
        this.elements.splice(this.deleteIndex, 1);
        this.deleteIndex = null;
      } else {
        this.elements.splice(0, this.elements.length);
      }
      this.showDelConfirm = false;
    },
    cancelDeletion() {
      this.deleteIndex = null;
      this.showDelConfirm = false;
    },
    confirmElementDialog(elt) {
      let eltPourCollection = {
        idElement: elt.element.id,
        element: elt.element.libelle,
        idMateriau: elt.materiau.id,
        materiau: elt.materiau.libelle,
      };
      if (this.editIndex != null) {
        this.elements.splice(this.editIndex, 1, eltPourCollection);
      } else {
        this.elements.push(eltPourCollection);
      }
      this.showDialog = false;
    },
    append() {
      this.editIndex = null;
      this.editedElement = null;
      this.showDialog = true;
    },
    edit(index) {
      this.editIndex = index;
      this.showDialog = true;
    },
  },
};
</script>

<style></style>
